module.exports = __webpack_public_path__ + "img/108.6.56d869ad.png";